// @flow
import SidePane from 'esm-web-pro/components/layout/SidePane';
import {
    Box, Button, Stack, Text,
} from 'grommet';
import styled from 'styled-components';
import * as React from 'react';
import Filter from 'esm-web-pro/components/tables/Filter';
import { FormattedMessage } from 'react-intl';
import FormStylesContext from 'speed-js-react-web/src/context/FormStylesContext';
import { SchemaForm } from 'speed-js-react';
import * as sidePanelActions from 'esm-web-pro/redux/side-panel/actions';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import endsWith from 'lodash/endsWith';
import { makeGetSidePanel } from 'esm-web-pro/redux/side-panel';
// import { getTableSpecificKey } from 'esm-web-pro/containers/tables/ColumnSettingsSidepanel';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';

const HiddenSubmitButton = styled.button`
  height: 0;
  font-size: 0;
  padding: 0;
  min-height: 0;
  margin-bottom: -20px;
  opacity: 0;
  visibility: hidden;
`;

type SidePanelActionProps = {
    openPanel: (
        key: string, title?: string | Object, url: ?string, skipSensitivity?: boolean,
    ) => { key: string, url: string },
    closePanel: (key: string, skipSensitivity?: boolean) => { key: string },
    closeAllPanels: (skipSensitivity?: boolean) => { },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    onSubmit: Function,
    schema: Object,
    initialValues: Object,
    buttonProps: Object,
    match: Object,
    history: Object,
    storageKey: string,
    filtersNumber: number,
    isPanelOpened: boolean,
    tableId: string,
}

type State = {
    openFilter: boolean,
    filtersCount: number,
    initial: Object,
    initialResetCounter: number,
}

const FILTER_EDIT = 'FILTER_EDIT_KEY';

// eslint-disable-next-line require-jsdoc
class FilterSidebarLayer extends React.Component<Props, State> {
    static defaultProps = {
        buttonProps: {},
        initialValues: {},
    };

    COLUMN_SETTINGS_EDIT_KEY = 'COLUMN_SETTINGS_EDIT_KEY';

    FILTER_EDIT = 'FILTER_EDIT_KEY';

    state = {
        openFilter: false,
        filtersCount: 0,
        initial: {},
        // eslint-disable-next-line react/no-unused-state
        initialResetCounter: 0,
    };

    componentTitle = <FormattedMessage id="filters-title" defaultMessage="Filters" />;

    constructor(props: Props) {
        super(props);
        this.formikRef = React.createRef(null);
    }

    componentDidMount() {
        const { storageKey, initialValues } = this.props;
        let filterSessionStorage = sessionStorage.getItem(storageKey);
        if (filterSessionStorage) {
            filterSessionStorage = JSON.parse(filterSessionStorage);
        }
        const count = filterSessionStorage ? Object.values(filterSessionStorage)
            .filter((v) => ((v !== null || undefined || '') && v[0] !== undefined)).length : 0;

        this.setState({ filtersCount: count, initial: filterSessionStorage || initialValues });
    }

    componentDidUpdate(prevProps) {
        const { storageKey, initialValues } = this.props;

        if (prevProps.storageKey !== storageKey) {
            let filterSessionStorage = sessionStorage.getItem(storageKey);
            if (filterSessionStorage) {
                filterSessionStorage = JSON.parse(filterSessionStorage);
            }
            const count = Object.values(filterSessionStorage || initialValues).filter((v) => (
                (v !== null || undefined || '') && v[0] !== undefined
            )).length;

            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ filtersCount: count, initial: filterSessionStorage || initialValues });
        }
    }

    getTableSpecificKey = (tableId) => `${this.COLUMN_SETTINGS_EDIT_KEY}:${tableId}`;

    handleClose = () => {
        const { closePanel, tableId, schema: { fields } } = this.props;
        this.setState({ openFilter: false });
        closePanel(FILTER_EDIT, true);

        // Set the initial values to the ones that are currently used to filter the table, so that when the user
        // re-opens the panel he will see the correct values, instead of the ones that have been last changed
        // but not submitted, e.g. submit the form with e status filter, but then the reset buttons is clicked
        // and the panel is closed.
        const storageKey = `tables:${tableId}`;
        let currentValueObj = sessionStorage.getItem(storageKey);
        if (currentValueObj) {
            currentValueObj = JSON.parse(currentValueObj);
        } else {
            currentValueObj = {};
        }
        fields.forEach((field) => {
            const name = field[0];

            if (field[1].type === 'date_range') {
                if (typeof currentValueObj[`${name}_before`] === 'undefined') {
                    currentValueObj[`${name}_before`] = null;
                }
                if (typeof currentValueObj[`${name}_after`] === 'undefined') {
                    currentValueObj[`${name}_after`] = null;
                }
            } else if (typeof currentValueObj[name] === 'undefined') {
                currentValueObj[name] = null;
            }
        });
        this.setState((prevState) => {
            const initial = {
                ...prevState.initial,
                ...currentValueObj,
                initialResetCounter: prevState.initialResetCounter + 1,
            };

            return { initial, initialResetCounter: prevState.initialResetCounter + 1 };
        });
    };

    handleSubmit = (values: Object, formik: Object) => {
        const { onSubmit } = this.props;
        const count = Object.values(values)
            .filter((v) => ((v !== null || undefined || '') && v[0] !== undefined)).length;
        onSubmit(values, formik);
        this.setState({
            filtersCount: count,
        });
    };

    loadDefault = () => {
        const { schema: { fields }, initialValues } = this.props;
        const emptyInitials = {};
        fields.forEach((field) => {
            emptyInitials[field[0]] = null;
            if (field[1].type === 'date_range') {
                emptyInitials[`${field[0]}_before`] = null;
                emptyInitials[`${field[0]}_after`] = null;
            }
        });
        const initial = { ...emptyInitials, ...initialValues };
        this.setState({
            initial,
        });
        // NIKO: For some reason we need to call setValues here, but not in handleReset. TODO: research why and fix
        if (this.formikRef.current) {
            this.formikRef.current.getFormikBag().setValues(initial);
        }
    }

    handleReset = () => {
        const { schema: { fields } } = this.props;
        this.setState((prevState) => {
            // Needed so that Formik will detect a change in the initial values after selecting the Reset button
            // consecutive times without submitting/closing the panel
            const initial = { initialResetCounter: prevState.initialResetCounter + 1 };

            fields.forEach((field) => {
                initial[field[0]] = null;
                if (field[1].type === 'date_range') {
                    initial[`${field[0]}_before`] = null;
                    initial[`${field[0]}_after`] = null;
                }
            });

            return { initial, initialResetCounter: prevState.initialResetCounter + 1 };
        });
    };

    handleOpen = () => {
        const {
            openPanel, match, closeAllPanels, history, closePanel, tableId,
        } = this.props;
        this.setState({
            openFilter: true,
        });
        closeAllPanels();
        history.push(match.url);
        this.compareFilterValues();
        closePanel(`${this.COLUMN_SETTINGS_EDIT_KEY}:${tableId}`, true);
        closeAllPanels();
        openPanel(FILTER_EDIT, this.componentTitle, match.url, false);
    };

    compareFilterValues = () => {
        const { initialValues, tableId } = this.props;
        const currentValues = this.formikRef.current?.getFormikBag().values || {};
        const sessionValues = JSON.parse(sessionStorage.getItem(`tables:${tableId}`)) || {};
        currentValues.initialResetCounter = '';
        const currentValuesString = Object.values(currentValues).join('');

        const valuesToString = (values) => {
            let result = '';
            Object.keys(values).sort().forEach((key) => {
                if (values[key] !== null && values[key] !== undefined && values[key] !== '') {
                    result += `${key}:${values[key]}`;
                }
            });
            return result;
        };

        const currentValuesStr = valuesToString(currentValues);
        const initialValuesStr = valuesToString(initialValues);
        const sessionValuesStr = valuesToString(sessionValues);

        const compareCurrentAndInitial = currentValuesStr === initialValuesStr;
        const compareCurrentAndSession = currentValuesStr === sessionValuesStr;
        const compareInitialAndSession = initialValuesStr === sessionValuesStr;

        return [
            currentValuesString === '',
            compareCurrentAndInitial,
            compareCurrentAndSession,
            compareInitialAndSession,
        ];
    }

    createFormContextObject = () => {
        const { tableId } = this.props;
        const currentValues = this.formikRef.current?.getFormikBag().values || {};
        if (this.formikRef?.current) {
            const sessionValues = sessionStorage.getItem(`tables:${tableId}`)
                ? JSON.parse(sessionStorage.getItem(`tables:${tableId}`))
                : {};
            const formContextObject = { ...currentValues };

            for (let i = 0; i < Object.keys(currentValues).length; i += 1) {
                const currentKey = Object.keys(currentValues)[i];
                if (Array.isArray(currentValues[currentKey]) && Array.isArray(sessionValues[currentKey])) {
                    if (currentValues[currentKey].join('') !== sessionValues[currentKey].join('')) {
                        formContextObject[currentKey] = { border: '3px solid rgba(253,208,137,1)', apply: true };
                    } else {
                        formContextObject[currentKey] = { border: '1px solid rgba(0, 0, 0, 0.33)', apply: false };
                    }
                } else if (Array.isArray(currentValues[currentKey]) && !Array.isArray(sessionValues[currentKey])) {
                    if (currentValues[currentKey].length > 0) {
                        formContextObject[currentKey] = { border: '3px solid rgba(253,208,137,1)', apply: true };
                    } else {
                        formContextObject[currentKey] = { border: '1px solid rgba(0, 0, 0, 0.33)', apply: false };
                    }
                } else if (!Array.isArray(currentValues[currentKey]) && Array.isArray(sessionValues[currentKey])) {
                    if (sessionValues[currentKey].length > 0) {
                        formContextObject[currentKey] = { border: '3px solid rgba(253,208,137,1)', apply: true };
                    } else {
                        formContextObject[currentKey] = { border: '1px solid rgba(0, 0, 0, 0.33)', apply: false };
                    }
                } else if (!Array.isArray(currentValues[currentKey]) && !Array.isArray(sessionValues[currentKey])) {
                    if (!currentValues[currentKey] && !sessionValues[currentKey]) {
                        formContextObject[currentKey] = {};
                    } else if (currentValues[currentKey] !== sessionValues[currentKey]) {
                        formContextObject[currentKey] = { border: '3px solid rgba(253,208,137,1)', apply: true };
                    } else {
                        formContextObject[currentKey] = { border: '1px solid rgba(0, 0, 0, 0.33)', apply: false };
                    }
                }
            }
            return formContextObject;
        }
        return {};
    }

    actions = (isSubmitting: boolean) => (
        <ActionButtons
            onClose={this.handleReset}
            clearButtonLabel={<FormattedMessage id="filters-btn-reset" defaultMessage="Reset" />}
            onDefault={this.loadDefault}
            defaultButtonLabel={<FormattedMessage id="filters-btn-default" defaultMessage="Default" />}
            onSave={(e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                if (this.formikRef.current) {
                    this.formikRef.current.getFormikBag().submitForm();
                }
            }}
            filterButtonLabel={<FormattedMessage id="filters-btn-filter" defaultMessage="Filter" />}
            disabled={isSubmitting}
            disabledReset={this.compareFilterValues()[0]}
            disabledDefault={this.compareFilterValues()[1]}
            disabledSubmit={this.compareFilterValues()[2]}
        />
    )

    renderForm = (
        props: {
            handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => void,
            handleReset: () => void,
        },
        fields: { [string]: React.Node },
    ) => {
        const { handleSubmit, handleReset } = props;

        return (
            <Box as="form" onSubmit={handleSubmit} onReset={handleReset} flex height="100%">
                <Box gap="small" justify="start" alignContent="start" overflow="auto" pad="medium" flex>
                    {/* $FlowFixMe */}
                    {Object.values(fields)}
                    {/* Required to allow submitting the form using the Enter key,
                    since the actions are not outside the form */}
                    <HiddenSubmitButton type="submit">
                        Submit
                    </HiddenSubmitButton>
                </Box>
            </Box>
        );
    };

    renderLayer =(
        props: {
            handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => void,
            handleReset: () => void,
            loadDefault: () => void,
            isSubmitting: boolean,
        },
        fields: { [string]: React.Node },
    ) => {
        const { isPanelOpened } = this.props;
        let layer = null;
        if (isPanelOpened) {
            layer = (
                <FormStylesContext.Provider value={this.createFormContextObject()}>
                    <SidePane
                        id={FILTER_EDIT}
                        title={this.componentTitle}
                        onClose={this.handleClose}
                        // TODO There is no isSubmitting prop.
                        actions={this.actions(props.isSubmitting)}
                        style={{
                            borderRight: '1px solid #3a3a3a',
                            borderRadius: '0px',
                            width: '300px',
                        }}
                    >
                        {this.renderForm(props, fields)}
                    </SidePane>
                </FormStylesContext.Provider>
            );
        }

        return layer;
    };

    render() {
        const {
            schema, buttonProps, isPanelOpened,
        } = this.props;
        const { openFilter, filtersCount, initial } = this.state;

        return (
            <React.Fragment>
                <Button
                    onClick={isPanelOpened ? this.handleClose : this.handleOpen}
                    hoverIndicator="light-1"
                    pad={{ vertical: '10px', horizontal: 'small' }}
                    style={{ backgroundColor: isPanelOpened ? '#F8F8F8' : '' }}
                    {...buttonProps}
                >
                    <Box pad={{ vertical: '10px', horizontal: 'small' }}>
                        <Stack
                            anchor="top-left"
                        >
                            <Box>
                                <Filter />
                            </Box>
                            {(filtersCount !== 0) && (
                                <Box
                                    background={this.compareFilterValues()[3] ? 'green' : 'red'}
                                    pad={{ horizontal: '4px' }}
                                    round
                                    style={{ position: 'relative', top: '-5px', left: '-2px' }}
                                >
                                    <Text weight="bold" color="white" size="10px">{filtersCount}</Text>
                                </Box>
                            )}
                        </Stack>
                    </Box>
                </Button>
                <SchemaForm
                    schema={schema}
                    onSubmit={this.handleSubmit}
                    onReset={this.handleReset}
                    onDefault={this.loadDefault}
                    enableReinitialize
                    initial={initial}
                    formikRef={this.formikRef}
                >
                    {this.renderLayer}
                </SchemaForm>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => (
    bindActionCreators(sidePanelActions, dispatch)
);

const getFiltersPanelOpened = makeGetSidePanel(FILTER_EDIT);

const mapStateToProps = (state) => ({
    isPanelOpened: !!getFiltersPanelOpened(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterSidebarLayer));
